import { Permission } from "./permissions";

/**
 * Gate de rota. Uma permissão exige aquela; uma LISTA exige ao menos uma ("qualquer uma").
 *
 * Existe para que menu (`Links.tsx`) e roteador (`layout/admin`) usem a mesma regra — se divergirem,
 * o item aparece e leva ao fallback da home.
 */
export const podeAcessarRota = (
  can: (permission: Permission) => boolean,
  permission: Permission | readonly Permission[]
): boolean => (Array.isArray(permission) ? permission.some((p) => can(p)) : can(permission as Permission));
